// extracted by mini-css-extract-plugin
export default {"main_visual":"home2_main_visual__y5yoh"};